import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ErrorText from "../components/ErrorText";
import Header from '../components/Header';
import Footer from '../components/Footer';
var NotFound = function () {
    return (_jsxs(_Fragment, { children: [_jsx(Header, {}), _jsx(ErrorText, {}), _jsx(Footer, {})] }));
};
export default NotFound;
